import ShowAlertDialog from '@/hooks/show-alert-dialog'
import { DeleteIcon } from './Icons/TooltipIcon'

export interface DeleteButtonProps {
    action: () => void
    title: string
    message: string
    tooltip?: string
    className?: string
    cancelled?: (cancelled : boolean) => void
}

const DeleteButton = ({ action, title, message, tooltip, className, cancelled }: DeleteButtonProps) => {
    return (
        <ShowAlertDialog
            action={action}
            title={title}
            message={message}
            cancelled={cancelled}
        >
            <button className={"rounded-md m-2 p-1 hover:bg-red-600 cursor-pointer " + className}>
                <DeleteIcon
                    tooltip={tooltip ? tooltip : "Delete"}
                />
            </button>
        </ShowAlertDialog>
    )
}

export default DeleteButton